import 'react-image-lightbox/style.css';

import React, { useState } from 'react';

import Image from 'next/image';
import Lightbox from 'react-image-lightbox';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import useMobile from '../../utils/useMobile';

const ImageWrapper = styled.div`
  position: relative;
  width: 100%;
  height: ${({ height, isMobile }) => (height || isMobile ? 200 : 400)}px;
  cursor: ${({ withZoom }) => withZoom && 'zoom-in'};
  margin-bottom: ${({ mb }) => mb || 0}px;
`;

const ZoomIcon = styled.div`
  position: absolute;
  width: 34px;
  height: 34px;
  top: 20px;
  right: 20px;
  z-index: 2;
  background-color: ${({ theme }) => theme.color.brand.accent};
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 50%;
`;

const BlockImage = ({ src, height, withZoom, objectFit, mb }) => {
  const [isOpen, setIsOpen] = useState(false);
  const lightboxId = Math.floor(Math.random() * 1000 + 1);

  const { isMobile } = useMobile();

  return (
    <>
      <ImageWrapper
        height={height}
        onClick={() => setIsOpen(prev => !prev)}
        withZoom={withZoom}
        mb={mb}
        isMobile={isMobile}
      >
        {withZoom && (
          <ZoomIcon>
            <Image
              src="/static/images/icons/search.svg"
              width={14}
              height={14}
              objectFit="contain"
              unoptimized
            />
          </ZoomIcon>
        )}
        <Image
          src={src}
          layout="fill"
          objectFit={objectFit || 'cover'}
          unoptimized
        />
      </ImageWrapper>
      {withZoom &&
        isOpen && (
          <Lightbox
            wrapperClassName={`lightbox-img-${lightboxId}`}
            mainSrc={src}
            onCloseRequest={() => setIsOpen(false)}
            enableZoom={true}
            imagePadding={20}
            onAfterOpen={() => {
              document
                .querySelector(
                  `.lightbox-img-${lightboxId}>.ril-toolbar>.ril-toolbar-right>.ril-toolbar__item>button[aria-label="Zoom in"]`
                )
                .click();
            }}
          />
        )}
    </>
  );
};

BlockImage.propTypes = {
  src: PropTypes.string.isRequired,
  height: PropTypes.number,
  withZoom: PropTypes.bool,
  objectFit: PropTypes.oneOf(['cover', 'contain']),
  mb: PropTypes.number
};

export default BlockImage;
